import { MenuButton as CarbonMenuButton, MenuButtonProps } from "@carbon/react";
import "./MenuButton.module.scss";

const MenuButton = (props: Omit<MenuButtonProps, "ref">) => {
  return <CarbonMenuButton {...props} />;
};

export default MenuButton;
